<template>
  <Layout>
    <div class="mc-list-header">
      <PageHeader :title="title" :items="breadCrumbItems" hasBreadcrumb />
      <div class="clearfix mc-btn-group__list mc-btn-group__list--detail">
        <McButtonBack class="d-inline-block me-2" />
        <McButton
          variant="primary"
          icon="icon-fill_plus"
          :text="$t('global.addField')"
          @click="$refs['token-api-table-ref'].HandleAdd()"
          class="d-inline-block"
        />
      </div>
    </div>

    <TokenAPITable ref="token-api-table-ref" />
  </Layout>
</template>

<script>
import appConfig from '@/app.config'
import Layout from '@/router/layouts/main'
import PageHeader from '@/components/page-header-v2'
import McButton from '@/components/McButton'
import McButtonBack from '@/components/McButtonBack'

import TokenAPITable from '../components/TokenAPITable'

export default {
  page: {
    title: 'Setting',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    McButton,
    TokenAPITable,
    McButtonBack,
  },
  data() {
    return {
      isEditingRow: null,
      isAdding: false,
      isSubmitting: false,
      isBusy: true,
      limit: 10,
      page: 1,
      totalCount: 0,
      search: '',
      formValues: {},
      items: [],
      limitOptions: [10, 25, 50, 100],
    }
  },
  computed: {
    title() {
      return this.$t('setting.list.development.newTitle')
    },
    breadCrumbItems() {
      return [
        {
          text: this.$t('setting.list.development.setting'),
          to: '/setting',
        },
        {
          text: this.$t('setting.homePage.tokenApi'),
          to: '/setting/token-api',
        },
        {
          text: this.$t('setting.list.development.newTitle'),
        },
      ]
    },
  },
}
</script>
